import { EntityKind } from 'mdello-client-ts/dist/src/interfaces/admin/entity.interface';
import { Profile } from 'mdello-client-ts/dist/src/interfaces/providers/ecommerce/profile.interface';
import { useQuery } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { getClient } from 'src/util/mdello-instance';
import { ProfilesResponseData } from './interfaces/suppliers.interface';

const fetchSuppliers = async (): Promise<ProfilesResponseData | undefined> => {
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  const data = await getClient()?.listEntities({
    kind: EntityKind.PROFILE,
    projectId: currentProject._id
  });

  if (!data) return;

  const filteredData = data.data.filter((profile: Profile) => {
    return profile.type === 'supplier';
  });

  return { data: filteredData, paging: filteredData.length };
};

export const useGetSuppliers = () => {
  const { notify } = useNotification();

  return useQuery([QueryKey.SELLERS], () => fetchSuppliers(), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
    }
  });
};
